<template>
  <WebToolTip
    ref="tooltip"
    v-bind="$attrs"
    role="popover"
    max-width="600"
    interactive-border="16"
    interactive
    allow-html
  >
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps" />
    </template>
  </WebToolTip>
</template>


<script setup lang="ts">
import WebToolTip from '@zotlo-shared/components/tooltip/index.vue';
</script>
